import CalmDonationFrequencyToggle from '~/javascripts/components/DonateForm/CalmDonationFrequencyToggle';
import cx from 'classnames';
import store from '~/javascripts/store.js';
import t from '~/javascripts/utils/translation.js';
import { Component } from 'react';
import {
  amountWithPrecisionAsRequired,
  amountWithPrecisionAsRequiredAndComma,
} from '~/javascripts/utils/numberFormatter';
import { observer } from 'mobx-react';

const DonateFormHeader = observer(
  class DonateFormHeader extends Component {
    handleEditAmountClick = () => {
      if (!store.donateForm.editAmountDisabled) {
        store.donateForm.step = 'amount';
        store.donateForm.creditCardStep = 1;
        store.donateForm.isWpsAmountButtonSelected = false;

        if (store.donateForm.subscriptionUpsell.isOptedIn) {
          store.donateForm.subscriptionUpsell.toggleIsOptedIn(
            store.donateForm.isAnnual ? 'annual' : 'monthly',
            false
          );
        }
      }
    };

    amountStepHeader = () => {
      if (this.props.amountStepHeader) return this.props.amountStepHeader;

      const verb = this.props.showAmountInput ? 'enter' : 'choose';

      return `${t(
        `views.donate_form.${verb}_amount`
      )} ${this.headerTextSubscriptionPeriod()}`;
    };

    headerTextSubscriptionPeriod = () => {
      if (store.donateForm.isSubscription) {
        return store.donateForm.isAnnual
          ? t('views.donate_form.per_year')
          : t('views.donate_form.per_month');
      } else {
        return '';
      }
    };

    calmPaymentStepHeader = () => {
      if (this.props.paymentStepHeader) return this.props.paymentStepHeader;

      return `${t('views.donate_form.giving')} ${
        store.donateForm.currencyUnit
      }${amountWithPrecisionAsRequired(
        store.donateForm.amount
      ).toUpperCase()} ${store.donateForm.currencyName.toUpperCase()} ${this.headerTextSubscriptionPeriod()}`;
    };

    paymentStepHeader = () => {
      if (this.props.paymentStepHeader) return this.props.paymentStepHeader;

      return `${t('views.donate_form.giving')} ${
        store.donateForm.currencyUnit
      }${amountWithPrecisionAsRequiredAndComma(
        store.donateForm.amount
      )} ${this.headerTextSubscriptionPeriod()}`;
    };

    hasAmountStepHeaderAndDescription = () =>
      this.props.amountStepHeader && this.props.amountStepDescription;

    amountHeaderAndDescriptionHtml = () => (
      <div className='px-2 my-1'>
        <h3
          className='text-base'
          dangerouslySetInnerHTML={{
            __html: this.props.amountStepHeader,
          }}
        />

        <p
          className='mt-1'
          dangerouslySetInnerHTML={{
            __html: this.props.amountStepDescription,
          }}
        />
      </div>
    );

    embedSuccessHtml = () => (
      <div className='adf-form-header text-center'>
        <span className='font-normal body-xs'>
          Your donation was processed successfully! Please check your email for
          a copy of your tax receipt.
        </span>
      </div>
    );

    calmModeHtml = () => {
      const { isValidEmail, step } = store.donateForm;

      return (
        <div className='adf-form-header text-center calm-header'>
          {step == 'amount' && <CalmDonationFrequencyToggle />}
          {step !== 'amount' && isValidEmail && (
            <span className='header-step-payment'>
              <span className='flex items-center justify-center'>
                <span
                  className='font-normal'
                  dangerouslySetInnerHTML={{
                    __html: this.calmPaymentStepHeader(),
                  }}
                />

                {(!this.props.skipAmountStep || this.props.allowAmountEdit) && (
                  <a
                    className={cx('edit-amount calm-edit-amount p-0', {
                      'text-grey-40': store.donateForm.editAmountDisabled,
                    })}
                    dangerouslySetInnerHTML={{
                      __html: `${t('views.donate_form.edit')}`,
                    }}
                    onClick={this.handleEditAmountClick}
                  />
                )}
              </span>
            </span>
          )}
          {step === 'payment' && !isValidEmail && (
            <span className='header-step-payment'>
              {t('views.donate_form.error')}
            </span>
          )}
        </div>
      );
    };

    calmAmountHeaderAndDescriptionHtml = () => (
      <>
        <div className='mb-2'>{this.calmModeHtml()}</div>
        {this.amountHeaderAndDescriptionHtml()}
      </>
    );

    defaultHtml = () => {
      const { isValidEmail, step } = store.donateForm;

      return (
        <span className='adf-form-header text-center'>
          {step == 'amount' && (
            <span
              dangerouslySetInnerHTML={{ __html: this.amountStepHeader() }}
            />
          )}
          {step !== 'amount' && isValidEmail && (
            <span className='header-step-payment'>
              <span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: this.paymentStepHeader(),
                  }}
                />

                {(!this.props.skipAmountStep || this.props.allowAmountEdit) && (
                  <a
                    className={cx('edit-amount p40', {
                      'text-grey-40': store.donateForm.editAmountDisabled,
                    })}
                    dangerouslySetInnerHTML={{
                      __html: `(${t('views.donate_form.edit_amount')})`,
                    }}
                    onClick={this.handleEditAmountClick}
                  />
                )}
              </span>
            </span>
          )}
          {step === 'payment' && !isValidEmail && (
            <span className='header-step-payment'>
              {t('views.donate_form.error')}
            </span>
          )}
        </span>
      );
    };

    render() {
      if (store.donateForm.step == 'embed-success') {
        return this.embedSuccessHtml();
      }

      if (
        store.donateForm.step == 'amount' &&
        this.hasAmountStepHeaderAndDescription()
      ) {
        if (store.donateForm.isCalmMode) {
          return this.calmAmountHeaderAndDescriptionHtml();
        }

        return this.amountHeaderAndDescriptionHtml();
      }

      if (store.donateForm.isCalmMode) {
        return this.calmModeHtml();
      }

      return this.defaultHtml();
    }
  }
);

export default DonateFormHeader;
